import styled from '@emotion/styled';
import { lpPageColors, mainColors } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';
import { RemoveTrashIcon } from 'src/assets/icons/RemoveTrashIcon';

interface QuickLinkTrayItemType {
    imgSrc?: string,
    isStart?: boolean,
    isEditLink?: boolean,
    homepage?: boolean
}

export const ContentContainer = styled('div', { label: 'ContentContainer' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const CampaignName = styled('span', { label: 'CampaignName' })`
    font-size: 14px;
    font-weight: ${fontWeight.bold};
    color: ${mainColors.main.primary};
    line-height: 1.4;
    padding-bottom: 8px;
`;

export const CampaignNameValue = styled('span', { label: 'CampaignNameValue' })`
    font-size: 12px;
    color: ${mainColors.main.primary};
    line-height: 1.2;
`;

export const TrashIconWrapper = styled(RemoveTrashIcon, { label: 'TrashIconWrapper' })`
    cursor: pointer;
    margin-left: 8px;
    align-self: center;
`;

export const ActiveLabel = styled('span', { label: 'ActiveLabel' })`
    color: ${lpPageColors.activeLabel};
    font-size: 12px;
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin-left: 12px;
`;

export const ImageContainer = styled('div', { label: 'ImageContainer' })`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    width: 60px;
    background-color: #878b96;
    margin-right: 16px;
`;

export const ImageTitleWrapper = styled('div', { label: 'ImageTitleWrapper' })`
    flex: 1 0 0%;
    display: flex;
    align-items: center;
`;

export const ImageWrapper = styled('div', { label: 'ImageWrapper' })<QuickLinkTrayItemType>`
    width: 100%;
    height: 100%;
    background-image: ${({imgSrc}): string => imgSrc !== undefined ? `url(${imgSrc})` : ''};
    background-size: cover;
`;
